var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsyncAction } from "nate-react-api-helpers";
import { useSyncedRef } from "../../../../misc/SyncedRef";
import { useSnackbar } from "../../../../misc/Snackbar";
import { useCallback, useState } from "react"; // throw from a snack action to stop it without showing an error (e.g. the user cancelled a confirm)
export class SnackActionCancelled extends Error {
}
export function useSnackAction(callback, props) {
    const callbackRef = useSyncedRef(callback);
    const successRef = useSyncedRef(props.success);
    const snack = useSnackbar();
    const [loading, setLoading] = useState(false);
    const action = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true); // without a success message the caller shows its own progress
            if (successRef.current)
                snack.loading();
            yield callbackRef.current(input);
            if (successRef.current)
                snack.success(successRef.current);
        }
        catch (e) {
            if (e instanceof SnackActionCancelled) {
                if (successRef.current)
                    snack.hide();
            }
            else {
                console.error(e);
                snack.error(e.message);
            }
        }
        setLoading(false);
    }), []);
    const actionCallbackRef = useSyncedRef(action.callback);
    const cb = useCallback(input => actionCallbackRef.current(input), [actionCallbackRef]);
    return { callback: cb, loading };
}
